interface PageHeroProps {
  eyebrow?: string;
  title: React.ReactNode;
  description?: string;
  image: string;
  imageAlt?: string;
  align?: "left" | "center";
  textColSpanClass?: string;
  imageColSpanClass?: string;
}

export const PageHero = ({
  eyebrow,
  title,
  description,
  image,
  imageAlt = "",
  textColSpanClass = "lg:col-span-7",
  imageColSpanClass = "lg:col-span-5",
}: PageHeroProps) => {
  return (
    <section className="relative pt-[4rem] pb-0 md:pb-24 bg-background overflow-hidden">
      <div className="container-page">
        <div className="grid gap-12 lg:grid-cols-12 lg:gap-16 items-center">
          <div className={textColSpanClass}>
            {eyebrow && (
              <div className="eyebrow animate-fade-up">— {eyebrow}</div>
            )}
            <h1 className="display-xl mt-8 text-foreground animate-fade-up delay-100 text-balance">
              {title}
            </h1>
            {description && (
              <p className="lead mt-8 max-w-xl animate-fade-up delay-200">
                {description}
              </p>
            )}
          </div>
          {image && (
            <div className={`${imageColSpanClass} animate-fade-in delay-200`}>
              <div className="relative aspect-[4/5] overflow-hidden rounded-sm flex items-center">
                <img
                  src={image}
                  alt={imageAlt}
                  width={1200}
                  height={1500}
                  fetchpriority="high"
                  decoding="async"
                  className="h-[350px] w-full object-cover flex items-center justify-center rounded-[15px]"
                />
                <div className="absolute inset-0 ring-1 ring-foreground/5" />
              </div>
            </div>
          )}
        </div>
      </div>
    </section>
  );
};
